import { TMUA_PEARSON_TOKENS } from '../constants/tmuaPearsonTokens';

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function getYesNoRestWidth(t = TMUA_PEARSON_TOKENS) {
  const trayOuter = t.ynDropzoneWidth + 2 * t.ynTrayPadX;
  return t.ynStatementRestWidth + t.ynStatementGap + t.ynDropzoneWidth + t.ynTrayGap + trayOuter;
}

export function getYesNoShrinkWidths(availablePx, t = TMUA_PEARSON_TOKENS) {
  const rest = getYesNoRestWidth(t);
  const pairShrink = 2 * (t.ynDropzoneWidth - t.ynDropzoneMinWidth);
  const deficit = Math.max(0, rest - availablePx);
  const dropWidth = clamp(
    t.ynDropzoneWidth - deficit / 2,
    t.ynDropzoneMinWidth,
    t.ynDropzoneWidth,
  );
  const statementWidth = Math.max(
    0,
    t.ynStatementRestWidth - Math.max(0, deficit - pairShrink),
  );
  const trayOuterWidth = dropWidth + 2 * t.ynTrayPadX;
  return { statementWidth, dropWidth, trayOuterWidth };
}

function lerp(value, inStart, inEnd, outStart, outEnd) {
  if (inStart === inEnd) return outStart;
  return outStart + ((value - inStart) / (inEnd - inStart)) * (outEnd - outStart);
}

function roundTo(value, decimals) {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function getYesNoTypeScale({ statementWidth, dropWidth }, t = TMUA_PEARSON_TOKENS) {
  const statementFloorWidth = Math.round(
    (t.ynStatementRestWidth * t.ynDropzoneMinWidth) / t.ynDropzoneWidth,
  );

  const tileFontSize = Math.round(
    clamp(
      lerp(dropWidth, t.ynDropzoneWidth, t.ynDropzoneMinWidth, t.ynTileFontRest, t.ynTileFontFloor),
      t.ynTileFontFloor,
      t.ynTileFontRest,
    ),
  );

  const statementFontSize = Math.round(
    clamp(
      lerp(
        statementWidth,
        t.ynStatementRestWidth,
        statementFloorWidth,
        t.ynStatementFontRest,
        t.ynStatementFontFloor,
      ),
      t.ynStatementFontFloor,
      t.ynStatementFontRest,
    ),
  );

  const statementLineHeight = roundTo(
    clamp(
      lerp(
        statementWidth,
        t.ynStatementRestWidth,
        statementFloorWidth,
        t.ynStatementLineHeightRest,
        t.ynStatementLineHeightFloor,
      ),
      t.ynStatementLineHeightFloor,
      t.ynStatementLineHeightRest,
    ),
    2,
  );

  return { statementFontSize, statementLineHeight, tileFontSize };
}
